import {Link} from '@shopify/hydrogen';
import clsx from 'clsx';
import Cart from '../cart/Cart.client';
import CartToggle from '../cart/CartToggle.client';
import {UserIcon} from '../icons/User';
import CountrySelect from './CountrySelect.client';
import LanguageSelect from './LanguageSelect.client';
import Container from './ContainerClient.client';

export default function HeaderActions() {
  return (
    <>
      <Container className="relative h-full">
        <Cart />
      </Container>
    </>
  );
}
